import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { PreloadAllModules, provideRouter, withComponentInputBinding, withPreloading } from "@angular/router";
import { KAuthProvider } from "@kortobaa-front/authentication";
import { Configuration, KNgDataTableModule } from "@kortobaa-front/k-ng-datatable";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { environment } from "../environments/environment";
import { AuthService } from "./auth/services/auth.service";
import { GlobalErrorHandler } from "./core/error-handler/global-error-handler.interceptor";
import { VendureAuthInterceptor } from "./core/interceptors/vendure-auth.interceptor";
import { routes } from "./core/routes/app.routes";
import { ArabicDatePipe } from "./shared/pipes/arabic-date.pipe";
import { DatePipePipe } from "./shared/pipes/date-pipe.pipe";
// import { PhoneCodePipe } from "../shared/pipes/phoneCode.pipe";
// import { checkLanguagePipe } from "../shared/pipes/checkLanguage.pipe";
import { MatButtonLoadingDirective } from "./shared/directives/mat-btn-loading.directive";

export const kNgDataTablePkgConfig: Configuration = {
  APIHost: environment.apiHost,
};

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

//firebase config
import { initializeApp } from "firebase/app";
initializeApp(environment.firebase);


export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withComponentInputBinding(),
    ),
    provideAnimations(),
    importProvidersFrom(
      TranslateModule.forRoot({
        // isolate: false,
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      })
    ),
    importProvidersFrom(KNgDataTableModule.forRoot(kNgDataTablePkgConfig)),
    importProvidersFrom(KNgDataTableModule),
    { provide: HTTP_INTERCEPTORS, useClass: GlobalErrorHandler, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: VendureAuthInterceptor, multi: true },
    AuthService,
    ArabicDatePipe,
    DatePipePipe,
    // PhoneCodePipe,
    // checkLanguagePipe,
    MatButtonLoadingDirective,
    { provide: KAuthProvider.default, useValue: { API_URL: environment.apiHost } },
  ],
};

